import VariableNameAnswers from '../context/types/VariableNameAnswers';
import { evaluate } from './logic/ProcedureLogicUtil';

/**
 * Get a promise that simply resolved to the given value
 * @param returnVal  any to return
 * @return      Promise<any> that was passed as an argument
 */
const getEmptyPromise = (returnVal: any): Promise<any> => new Promise((resolve) => resolve(returnVal));

// Helper to promisify the existing callback-based evaluate, if needed

const evaluateAsync = (engine: any, facts: VariableNameAnswers): Promise<void> => new Promise((resolve, reject) => {
  try {
    evaluate(engine, facts, () => {
      resolve(); // Resolve the promise when the evaluate callback fires
    });
  } catch (error) {
    console.error('Error invoking evaluate:', error);
    reject(error); // Reject the promise on synchronous error
  }
});

export { getEmptyPromise, evaluateAsync };
